const messsages = {
    "REQUEST_FAILED": "Не удалось выполнить запрос. Попробуйте повторить попытку."
};

export default messsages;


/** WEBPACK FOOTER **
 ** ./src/messages.js
 **/